import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import AngularHelperService from '../../services/angular-helper.service';

@Component({
	standalone: true,
	selector: 'modal-confirmation',
	templateUrl: './modal-confirmation.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ModalConfirmationComponent implements OnInit {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalConfirmationComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.content = this.vm.isHtmlContent ? this.angularHelperService.trustAsHtml(this.vm.content) : this.vm.content;
		this.handleCloseTimerInit(this.vm.bindings?.closeDelay);
		
		this.vm.cancel = this.cancel;
		this.vm.submit = this.submit;
	}
	
	handleCloseTimerInit(interval) {
		if (typeof interval !== 'undefined') this.vm.closeTimer = this.angularHelperService.createTimer(this.submit, interval);
	}
	
	handleCloseTimerDestroy() {
		if (this.vm.closeTimer) this.angularHelperService.cancelTimer(this.vm.closeTimer);
	}
	
	cancel() {
		this.handleCloseTimerDestroy();
		this.dialogRef.close();
	}
	
	submit(opts) {
		this.handleCloseTimerDestroy();
		this.dialogRef.close(opts);
	}
	
}